import { observable, makeAutoObservable, configure  } from 'mobx'
import { SelectBox } from './componentStore';

configure({
  enforceActions: "never",
})

class ErrorStore {
  constructor(){
    makeAutoObservable(this)
  }

  message = null
  isError = false

  setErrorMessage(message, isError){
    this.message = message
    this.isError = isError
  }

  unsetError(){
    this.message = null
    this.isError = false
  }

}

export default new ErrorStore